// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"az_THb","labelLinkItem":"az_UHb","commonCookieBtnStyles":"az_VHb","cookieButtonElement":"az_WHb","cookieStick":"az_XHb"};